import { useLocation } from 'react-router-dom';
import StepProgressiveBar from '@components/molecule/auth/stepProgressiveBar';

const SignUpVerification = () => {
  const { state } = useLocation() as { state: { email: string } };
  console.log('SignUpVerificationState: ', state);
  return (
    <>
      {state?.email && (
        <div className="other-layout join">
          <div className="main-content">
            <header className="header">
              <div className="header-inner">
                <h1 className="header-logo">
                  <img src="/images/logo-axo-app.png" alt="axo" />
                </h1>

                <label className="select type-1">
                  <select>
                    <option>ENG</option>
                    <option>JP</option>
                    <option>KOR</option>
                  </select>
                </label>
              </div>
            </header>
            <div className="container">
              <div>
                <div className="manager">
                  <div>
                    <StepProgressiveBar step="step1" />
                  </div>
                  <h2 className="manager-tit">Check your email</h2>
                  <p className="manager-dsc">
                    You need to verify the email address you applied for. Please check your email.
                  </p>
                </div>

                <p className="join-email-user">
                  <span>{state.email}</span>
                </p>

                <p className="join-caution1">
                  E-mails that have been applied for more than two weeks will be automatically deleted
                </p>

                <p className="join-caution2">If you can't find the mail, please check the spam box</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignUpVerification;
